import React from "react";
import { Box, IconButton, InputBase } from "@mui/material";
import { RiCloseLine, RiSearchLine } from "@remixicon/react";
import { focusRing, tokens } from "../../utils/figmaTokens";

// Admin · Search Field (10594:24; 260 px in the Users toolbar 10661:12985): grey at rest; white
// with a 1.5 px brand ring while focused, drawn inside so nothing moves; a clear button once it
// holds text. The icon darkens when focused or filled, as Figma's Focus and Filled states do.
const SearchField = ({ value, onChange, placeholder }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "9px",
      width: { xs: "100%", sm: 260 },
      height: 40,
      px: "12px",
      borderRadius: "10px",
      bgcolor: tokens.surface.muted,
      color: value ? tokens.icon.default : tokens.text.tertiary,
      "&:focus-within": {
        bgcolor: tokens.surface.default,
        boxShadow: `inset 0 0 0 1.5px ${tokens.brand.border}`,
        color: tokens.icon.default,
      },
    }}
  >
    <RiSearchLine size={20} />
    <InputBase
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      slotProps={{ input: { "aria-label": placeholder } }}
      sx={{
        flex: 1,
        minWidth: 0,
        typography: "bodySmall",
        color: tokens.text.primary,
        "& input": { p: 0, height: 22 },
        "& input::placeholder": { color: tokens.text.tertiary, opacity: 1 },
      }}
    />
    {value && (
      // Keyboard focus shows D22's ring, not MUI's grey focus ripple (047 D73).
      <IconButton aria-label="Clear the search" onClick={() => onChange("")} disableFocusRipple sx={{ p: "2px", color: tokens.text.tertiary, ...focusRing }}>
        <RiCloseLine size={15} />
      </IconButton>
    )}
  </Box>
);

export default SearchField;
